import clsx from "clsx";
import React from "react";

interface StatisicBlockProps {
  label: string;
  value: number | string;
  quantifier?: string;
  onClick?: () => void;
}
export const StatisticBlock: React.FC<StatisicBlockProps> = (props) => {
  const { label, value, quantifier, onClick } = props;

  return (
    <div
      className={clsx(
        "flex flex-col items-center space-y-2",
        onClick && "touchable",
      )}
      onClick={onClick}
    >
      <span className="text-sm  text-gray-500">{label}</span>

      <div className="flex flex-row justify-center items-end space-x-1">
        <span
          className={clsx(
            "text-xl  text-gray-900",
            value === undefined && "w-8 h-4.5 bg-gray-200",
          )}
        >
          {value}
        </span>
        <span
          className={clsx(
            "text-sm  text-gray-500",
            value === undefined && "w-8 h-4.5 bg-gray-200",
          )}
        >
          {quantifier}
        </span>
      </div>
    </div>
  );
};
